import { createSortedOptions } from 'src/apps/mfa/helpers/QueryHelpers';
import { IMfaLabelOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { naturalSort } from 'src/common/helpers/DataFilterHelper';

import { MfaLabelOptionsQuery } from '../MfaLabelOptions.generated';

const APP_NAME = 'appName';
const APP_VERSION = 'versions';

export const transformMfaLabelOptionsResults = (
	rawResults: MfaLabelOptionsQuery
): IMfaLabelOptions[] => {
	const sessions = rawResults.mfa_session_runs || [];
	const appValues = new Set<string>();
	const appVersionValues = new Set<string>();
	const customFieldsMap = new Map<string, Set<string>>();

	for (const session of sessions) {
		if (!session) {
			continue;
		}

		if (session.app?.length) {
			for (const app of session.app) {
				if (app?.trim()) {
					appValues.add(app);
				}
			}
		}

		if (session.app_version?.length) {
			for (const appVersion of session.app_version) {
				if (appVersion?.trim()) {
					appVersionValues.add(appVersion);
				}
			}
		}

		if (session.custom_fields?.length) {
			for (const customField of session.custom_fields) {
				const [labelKey, valueKey] = customField || [];

				if (labelKey?.trim() && valueKey?.trim() && labelKey !== APP_NAME) {
					if (!customFieldsMap.has(labelKey)) {
						customFieldsMap.set(labelKey, new Set<string>());
					}
					const valueSet = customFieldsMap.get(labelKey);
					if (valueSet) {
						valueSet.add(valueKey);
					}
				}
			}
		}
	}

	const result: IMfaLabelOptions[] = [];

	// Add app name options if available
	if (appValues.size > 0) {
		result.push({
			labelName: APP_NAME,
			labelKey: APP_NAME,
			options: createSortedOptions(appValues)
		});
	}

	// Add app version options if available
	if (appVersionValues.size > 0) {
		result.push({
			labelName: APP_VERSION,
			labelKey: APP_VERSION,
			options: createSortedOptions(appVersionValues)
		});
	}

	// Add custom field options
	for (const [labelKey, valuesSet] of customFieldsMap) {
		if (valuesSet.size > 0) {
			result.push({
				labelName: labelKey,
				labelKey,
				options: createSortedOptions(valuesSet)
			});
		}
	}

	return result.sort((a, b) => naturalSort(a.labelKey, b.labelKey));
};
